import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import documents from './documents'
import accountStatus from './accountStatus'
import users from './users'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        auth,
        documents,
        accountStatus,
        users
    }
})
